// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'
import Avatar               from 'material-ui/Avatar';
var Spinner = require('react-spinkit');
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import EditLead from '../editLead';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import ScheduleDemo from '../scheduleDemo';
import EditProfile from '../editProfile';
import ChildProfile from '../childProfile';
import CircularProgress from 'material-ui/CircularProgress';
import { Table } from 'reactstrap';
import { Multiselect } from 'react-widgets';
import  './index.css'

const customStyles = {
 

  content : {
    top                   : '2%',
    left                  : '2%',
    right                 : '2%',
    bottom                : '2%',
   
    
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '100000'
    
   }

}; 

const creditStyles = {
    content : {
    top                   : '10%',
    left                  : '10%',
    right                 : '10%',
    bottom                : '10%',
    height                : 'auto'
   
    
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '100000'
    
   }
}




class CustomerDetails extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      dialog_open: false,
      dialog_unpause_open:false,
      active_tab: (props.match.params.page == 'booking') ? 2 : 1,
      pause_date:'',
      rejoining_date:'',
      pause_start:moment(),
      subscription_id:'',
      support_tickets:[],
      session_feedbacks:[],
      customer_leads:[],
      customer_bookings:[],
      customer_subscriptions:[],
      result:[],
      activities:[],
      popUpVisible:false,
      name:'',
      pause_types: {},
      pause_type: 0,
      current_homebatches:[],
      deleted_homebatches:[],
      credit_balance: 0,
      show_history: false,
      pause_history: [],
      edit_size: false,
      edit_kit: false,
      edit_percent: false,
      jersey_size: '',
      no_of_kits: '',
      scholar_percent: '',
      scholar_amount: '',
      community_member_status:[],
      file:null,
      view_photo:false,
      addVerification:false,
      editVerification:false,
      venue_list:[],
      member_types:[],
      verification_details:{
        selected_venue_id:'',
        member_type:'',
        card_number:'',
      },
      card_image:null,
      end_date:'',
      addHomeBatch:false,
      prev_homeBatch:[],
      batch:'',
      venues:[],
      fixtures: [],
      selected_venue_id: '',
      selected_fixture_id: '',
      sub_id:'',
      last_lead_status:'',
      show_demo_options:false,
      demo_details:[],
      credit_details:[],
      credit_view:false,
      show_change_log:false,
      change_logs:[],
      kit_status:false,
      kit_sub:'',
      is_delivered:false,
      kit_ordered:0,
      kit_size:'',
      selected_kit_sub:'',
      show_delete_option:false,
      new_customer_id:'',
      selected_sub_id:'',
      selected_start_date:'',
      selected_end_date:'',
      selected_status:'',
      selected_package:'',
      selected_package_name:'',
      amount:'',
      buddies:[],
      selected_buddies:[],
      reason:'',
      packages:[],
      filtered_packages:[],
      search_field:false,
      show_packages:false,
      statuses:[],
      country_name:'',
      kit_fee_details:[],
      show_edit_inst: false,
      installment_no: '',
      installment_amount: '',
      edit_compensation_class:false,
      extra_classes:0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitUnpause = this.handleSubmitUnpause.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onClicked = this.onClicked.bind(this);
    this.handledate = this.handledate.bind(this);    
    this.handlepausedate = this.handlepausedate.bind(this);
    this.handlerejoindate = this.handlerejoindate.bind(this);
    this.pausehistory = this.pausehistory.bind(this);
    this.postStudentInfo = this.postStudentInfo.bind(this);
    this.validateStudentInfo = this.validateStudentInfo.bind(this);
    this.verifyStudent = this.verifyStudent.bind(this);
    this.setStudentVerified = this.setStudentVerified.bind(this);
    this.fileHandler = this.fileHandler.bind(this);
    this.handleexpdate = this.handleexpdate.bind(this);
    this.imageChange = this.imageChange.bind(this)
    this.addverification = this.addverification.bind(this)
    this.getdetailsforbatchadd = this.getdetailsforbatchadd.bind(this)
    this.getdetailsforbatchedit = this.getdetailsforbatchedit.bind(this)
    this.postHomeBatch = this.postHomeBatch.bind(this)
    this.canceldemo = this.canceldemo.bind(this)
    this.reschedleDemo = this.reschedleDemo.bind(this)
    this.getCreditDetails = this.getCreditDetails.bind(this)
    this.setkitstatus = this.setkitstatus.bind(this)
    this.handledeletecustomer = this.handledeletecustomer.bind(this)
    this.changestartdate = this.changestartdate.bind(this);
    this.changeenddate = this.changeenddate.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.openEditCompensationClass = this.openEditCompensationClass.bind(this)
    this.closeEditCompensationClass = this.closeEditCompensationClass.bind(this)
    this.editCompensationClass = this.editCompensationClass.bind(this)
  }

  handleTabClick(tabIndex){
        if(tabIndex==1 ){
          this.customerLeads();
        }else if(tabIndex==2 ){
          this.customerBookings();
        }else if(tabIndex==3  ){
          this.customerSubscriptions();
          // this.currentHomebatches();

        }
        else if(tabIndex==4 ){
          this.customerSupportTickets();
        }
        else if(tabIndex==5 ){
          this.customerSessionFeedbacks();
        }
        else if(tabIndex==6 ){
          this.customerAttendence();
        }
        else if(tabIndex==7 ){
          this.customerActivity();
        }





        this.setState({
            active_tab: tabIndex,
        });
    }

  

 

  closeModal() {
    this.setState({popUpVisible: false},()=>this.customerFulldetails());
    if(this.state.name == 'EditLead' || this.state.name == 'ScheduleDemo'){
      this.setState({active_tab:1},()=>this.customerLeads())
    }
  }

  onClicked(e){
    console.log('name')
    console.log(e)
    if(e == 'ScheduleDemo'){
      if(this.state.customer_leads[0] && this.state.customer_leads[0].status){
        const last_lead_status = this.state.customer_leads[0].status
        const message = "Cannot schedule demo since customer last lead status is " + last_lead_status
        if(last_lead_status == 'Payment Due' || last_lead_status == 'Paid'){
          alert(message)
        }
        else{
          this.setState({name:e, popUpVisible:true});
        }
      }
      else{
        this.setState({name:e, popUpVisible:true});
      }
    }
    else{
      this.setState({name:e, popUpVisible:true});  
    }
  }

  handleOpen = (id) => {
    this.setState({dialog_open: true});
    this.setState({subscription_id:id})
  };

  handleClose = () => {
    this.setState({dialog_open: false,dialog_unpause_open:false,view_photo:false});
  };


  componentDidMount() {
     this.customerFulldetails();
     this.customerLeads();
     this.getPauseTypes();
     this.getPackages();
     this.getBuddies()
  }


  customerFulldetails(){
    console.log('we are here in customerFulldetails')

    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data, credit_balance: data.credit_balance,community_member_status: data.community_member_status,country_name: data.country_name},()=>this.updateStudentInfoStates(data.profile_data)))
       .catch(error => error);
  }

  updateStudentInfoStates(profile_data){
    const jersey_size = profile_data[this.state.id].student_info.jersey_size
    const no_of_kits = profile_data[this.state.id].student_info.no_of_kit_received
    const scholar_percent = profile_data[this.state.id].student_info.scholarship_percentage
    const scholar_amount = profile_data[this.state.id].student_info.scholarship_amount
    this.setState({jersey_size: jersey_size, no_of_kits: no_of_kits, scholar_percent: scholar_percent,scholar_amount:scholar_amount})
  }

  customerLeads(id){
    var selected_id = this.state.id;
    if(id){
      selected_id = id
    }
    const url = `${getLocationOrigin()}/customer_list/get_customer_leads/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_leads:data.customer_leads.leads}))
       .catch(error => error);
  }


  customerBookings(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_bookings/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_bookings:data.customer_bookings.bookings}))
       .catch(error => error);

  }

  customerSubscriptions(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_subscriptions/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_subscriptions:data.customer_subscriptions[0].subscriptions}))
       .catch(error => error);
 
  }

  getPauseTypes(){
    const url = `${getLocationOrigin()}/subscriptionpause/get_pause_types/`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({pause_types:data.pause_types}))
       .catch(error => error);
  }

  getCreditDetails(){
    console.log("getCreditDetails")
    var mobile_no = this.state.profile_data[this.state.id].mobile_no
    const url = `${getLocationOrigin()}/sporthoodcreditadmin/credit_history_for_customer/?mobile_no=${mobile_no}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({credit_details:data.credit_history,credit_view:true}))
       .catch(error => error);
  }





  switchProfile(id, props){
    console.log('in switch profile')
    this.setState({dialog_open: false });
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${id}`;
    const options = {...defaultOptions};

    
    
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ jersey_size: '', no_of_kits: '', scholar_percent: '', profile_list: data.profile_list, profile_data: data.profile_data,  id: id, credit_balance:data.credit_balance,pause_type:0},()=>{
          this.handleTabClick(this.state.active_tab)
          this.updateStudentInfoStates(data.profile_data)
        }))
       .catch(error => error);
  }
  customerSupportTickets(){
    const url = `${getLocationOrigin()}/customer_list/get_support_tickets/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ support_tickets: data.support_tickets}))
       .catch(error => error);

 
  }

  customerSessionFeedbacks(){
    console.log('this is customerSessionFeedbacks ')
    const url = `${getLocationOrigin()}/customer_list/get_session_feedbacks/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ session_feedbacks: data.session_feedbacks}))
       .catch(error => error);
       
 
  }
  customerAttendence(){
    console.log('this is customerAttendence ')
    const url = `${getLocationOrigin()}/customer_list/get_player_attendance/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ result: data.result}))
       .catch(error => error);
      console.log('results')
      console.log(data.result)
 
  }

  currentHomebatches(){
    console.log('this is currentHomebatches ')
    const url = `${getLocationOrigin()}/customer_list/homebatches_details/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ current_homebatches: data.current_homebatches,deleted_homebatches:data.deleted_homebatches}))
       .catch(error => error);
      console.log('results....')
      console.log(data.result)
 
  }

  customerActivity(){
    console.log('this is customerActivity ')
    const url = `${getLocationOrigin()}/customer_list/get_customer_activities/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ activities: data.activities}))
       .catch(error => error);
      console.log('activities')
      console.log(data.activities)
  }

  pausehistory(event,sub_id) {
    const url = `${getLocationOrigin()}/customer_list/get_pause_details/?sub_id=${sub_id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ pause_history: data.pause_details,show_history:true}))
       .catch(error => error);
  }

  getchangehistory(event,sub_id){
    const url = `${getLocationOrigin()}/customer_list/get_subscription_change_logs/?sub_id=${sub_id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ change_logs: data.change_logs,show_change_log:true}))
       .catch(error => error);
  }

  handleChange(event) {
    var name = event.target.name;
    if (name == 'pause_type'){
      this.setState({pause_type: event.target.value})
    }
  }

  handledate(date) {
    this.setState({pause_start:date})
  }

  handlepausedate(date) {
    this.setState({pause_date:date})
  }

  handlerejoindate(date) {
    this.setState({rejoining_date:date})
  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.pause_date){
      this.postPauseSubscription(this.state.pause_date, this.state.pause_start, this.state.pause_type, this.state.subscription_id, this.props);
      
    }
    else{
      alert("Please Enter Date")
    }
    this.currentHomebatches()
    this.customerSubscriptions()
  }

  handleSubmitUnpause(event) {
    console.log('handlesubmit....')
    console.log(event.target.name)
    event.preventDefault();
    if(this.state.rejoining_date){
      this.postUnPauseSubscription(this.state.rejoining_date, this.state.subscription_id, this.props);
      
    }
    else{
      alert("Please Enter Date")
    }

    this.currentHomebatches()
      this.customerSubscriptions()
    
  }

  postUnPauseSubscription(rejoining_date, subscription_id, props){
    this.setState({dialog_unpause_open: false});
    var date = moment(rejoining_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY/MM/DD")
    const url = `${getLocationOrigin()}/subscriptionpause/unpause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'rejoining_date': date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
        
       })
       .then(this.currentHomebatches())
       .then(this.customerSubscriptions())
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  

  missedCallsms(props) {
    const url = `${getLocationOrigin()}/lead/lead_missed_call_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  postPauseSubscription(pause_date, pause_start, pause_type, subscription_id, props){
    if(pause_start == ''){
      pause_start = moment().toDate()
    }
    this.setState({dialog_open: false});
    var date = moment(pause_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    var start_date = moment(pause_start, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/subscriptionpause/pause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'pause_date': date,
                         'pause_type': pause_type,
                         'starting_pause_date': start_date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
       })
       .then(this.currentHomebatches())
       .then(this.customerSubscriptions())
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  venueSms(props) {
    const url = `${getLocationOrigin()}/lead/send_venue_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  connectCall(mobile_no) {
    const url = `${getLocationOrigin()}/calls/connect_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                                        'customer_no': mobile_no,
                                        'source':'CM'
                                          });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                     
          alert(response.message);
          // props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
    }  

    passToWhatsapp(mobile_no) {
      if(window.innerWidth < 992){
        window.open(`https://api.whatsapp.com/send?phone=91${mobile_no}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`
        ,'_blank')
      }
      else{
        window.open(`https://web.whatsapp.com/send?phone=91${mobile_no}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`
        ,'_blank')
      }
    }

    validateStudentInfo(type){
      if(type == 'size'){
        if(this.state.jersey_size.length > 0 && !isNaN(this.state.jersey_size)){
          this.postStudentInfo(type,this.state.jersey_size)
        }
        else{
          alert("Invalid Entry")
        }
      }
      if(type == 'kits'){
        if(this.state.no_of_kits.length > 0 && !isNaN(this.state.no_of_kits)){
          this.postStudentInfo(type,this.state.no_of_kits)
        }
        else{
          alert("Invalid Entry")
        }
      }
      if(type == 'percent'){
        if(this.state.scholar_percent.length > 0 && !isNaN(this.state.scholar_percent)){
          this.postStudentInfo(type,this.state.scholar_percent)
        }
        else{
          alert("Invalid Entry")
        }
      }
    }

    postStudentInfo(){
      if(this.state.no_of_kits === '' && this.state.jersey_size === '' && this.state.scholar_percent === '' && this.state.scholar_amount === ''){
        alert("Please choose a value")
      }
      else{
        const url = `${getLocationOrigin()}/customer_list/save_student_info/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                            'customer_id': this.state.profile_data[this.state.id].id,
                                            'no_of_kit_received': this.state.no_of_kits,
                                            'jersey_size': this.state.jersey_size,
                                            'scholarship_percentage': this.state.scholar_percent,
                                            'scholarship_amount': this.state.scholar_amount
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            alert(data.message)
            this.switchProfile(this.state.profile_data[this.state.id].id)
           })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }
    }

    verifyStudent(type){
      if(type == 'AddVerification'){
        this.setState({addVerification:true},()=>this.getdetailsforverification())
      }
      if(type == 'EditVerification'){
        this.setState({editVerification:true})
        this.getdetailsforverification()
        this.setdataforverification()
      }
      if(type == 'verified'){
        var msg = `Do You Want to Continue ?`;
        var result = confirm(msg);
        if (result == true){
          this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
        }
      }
      if(type == 'not_verified'){
        var msg = `Do You Want to Continue ?`;
        var result = confirm(msg);
        if (result == true){
          this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
        }
      }
      if(type == 'cancel_verification'){
        var msg = `Do You Want to Cancel Verification ?`;
        var result = confirm(msg);
        if (result == true){
          this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
        }
      }
      if(type == 'upload_photo'){
        if(this.state.file){
          var msg = `Do You Want to Upload Photo ?`;
          var result = confirm(msg);
          if (result == true){
            this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
          }
        }
        else{
          alert('Please Select a photo to Upload')
        }
      }
    }

    setStudentVerified(customer_id,type){
      const url = `${getLocationOrigin()}/customer_list/get_customer_verified/`;
      const options = {...defaultOptions};
      options['method'] = 'post';      
      var formData = new FormData();
      formData.append('customer_id',customer_id);
      formData.append('v_type',type);
      formData.append('file',this.state.file);      
      options['body'] = formData

      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          alert(data.message)
          this.setState({verified: false,file:'',open_file:false},()=>this.customerFulldetails())
         })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    fileHandler = (event) => {
      let file = event.target.files[0];
      this.setState({file :file});
    }

    getdetailsforverification(){
      console.log('getdetailsforverification ')
      const url = `${getLocationOrigin()}/customer_list/get_details_for_customer_verification/`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({venue_list:data.venue_list,member_types:data.member_types}))
         .catch(error => error);
    }

    handleInputChange(event) {
      console.log('handleChange..')
      console.log(event.target.value)
      const name = event.target.name;
      var new_selected_one = Object.assign({}, this.state.verification_details);
      new_selected_one[name] = event.target.value
      this.setState({verification_details: new_selected_one});
    }

    handleexpdate(date) {
      this.setState({end_date:date})
    }

    imageChange = (event) => {
      let file = event.target.files[0];
      this.setState({card_image :file});
    }

    handleVerifyClose=()=>{
      this.setState({addVerification:false,editVerification:false,addHomeBatch:false,
                      verification_details:{
                            selected_venue_id:'',
                            member_type:'',
                            card_number:'',},end_date:'',card_image:''})
    }

    addverification(){
      console.log('verification_details')
      if(this.state.verification_details.selected_venue_id == ''){
        alert("Please select a venue")
      }
      else if(this.state.end_date == ''){
        alert("Please select an end date")
      }
      else{
        var end_date = moment(this.state.end_date).format('YYYY-MM-DD')
        const url = `${getLocationOrigin()}/customer_list/add_verification_for_customer/`;
        const options = {...defaultOptions};
        options['method'] = 'post';      
        var formData = new FormData();
        formData.append('customer_id',this.state.profile_data[this.state.id].id);
        formData.append('venue_id',this.state.verification_details.selected_venue_id);
        formData.append('member_type',this.state.verification_details.member_type);
        formData.append('card_image',this.state.card_image);
        formData.append('card_number',this.state.verification_details.card_number);
        formData.append('end_date',end_date);
        options['body'] = formData

        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            alert(data.message)
            this.setState({addVerification:false,editVerification:false,end_date:'',card_image:'',
                          verification_details:{
                            selected_venue_id:'',
                            member_type:'',
                            card_number:''}},()=>this.customerFulldetails())
           })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }
    }

    setdataforverification(){
      console.log("setdataforverification")
      let venue_id = this.state.community_member_status.venue_id
      let member_type = this.state.community_member_status.member_type
      let end_date = moment(this.state.community_member_status.end_date)
      let card_number = this.state.community_member_status.card_number
      this.setState({end_date:end_date,
                          verification_details:{
                            selected_venue_id:venue_id,
                            member_type:member_type,
                            card_number:card_number}})
    }

  getdetailsforbatchadd(e,sub_id,type,venue_id){
    this.setState({addHomeBatch:true,sub_id:sub_id,batch:'Add',selected_venue_id:venue_id},()=>this.getVenues(false))
  }

  getdetailsforbatchedit(e,sub_id,type,venue_id,current_homebatch,current_homebatch_id){
    this.setState({addHomeBatch:true,sub_id:sub_id,batch:'Edit',prev_homeBatch:current_homebatch,selected_fixture_id:current_homebatch_id,selected_venue_id:venue_id},()=>this.getVenues(true))
  }


  getFixtures(val){
    var url = ''
    if(val == true){
       url = `${getLocationOrigin()}/fixture/get_homebatch_details/?subscription_id=${this.state.sub_id}&venue_id=${this.state.selected_venue_id}`;
    }
    else{
       url = `${getLocationOrigin()}/fixture/get_homebatch_details/?subscription_id=${this.state.sub_id}`;
    }     
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
              this.setState({fixtures: data.fixtures})
         }).catch(error => error);
  }

  getVenues(val){
    console.log("getVenues")
    const url = `${getLocationOrigin()}/court/get_buddy_venues/`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
              this.setState({venues:data.result},()=>this.getFixtures(val))
         }).catch(error => error);
  }

  handleVenueChange(event){
    this.setState({selected_venue_id:event.target.value,selected_fixture_id:''}, ()=>this.getFixtures(true))
  }

  handleBatchChange(event){
    this.setState({selected_fixture_id:event.target.value})
  }

  postHomeBatch(){
    if(this.state.selected_venue_id == ''){
      alert('Please select a venue')
    }
    else if(this.state.selected_fixture_id == '' || this.state.selected_fixture_id == '--select a fixture--'){
      alert('Please select a fixture')
    }
    else{
      const url = `${getLocationOrigin()}/fixture/save_homeBatch/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
          'subscription_id': this.state.sub_id,
           'fixture_id': this.state.selected_fixture_id,
           'venue_id': this.state.selected_venue_id
      });
      return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data =>{ 
             alert(data.message)
              this.setState({selected_fixture_id:'',selected_venue_id:'',addHomeBatch:false,sub_id:''},()=>this.customerSubscriptions())
            }
          )
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
    }
  }

  getDemoDetails(){
    this.setState({show_demo_options:true},()=>{
      this.get_last_demo_details()
    }) 
  }

  reschedleDemo(){
    this.setState({show_demo_options:false,demo_details:[]},()=>{
      this.onClicked('ScheduleDemo')
    })
  }

  canceldemo(){
    var msg = `Do You Want to Cancel Demo ?`;
    var result = confirm(msg);
    if (result == true){
      const url = `${getLocationOrigin()}/booking/cancel_demo_booking/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
          'customer_id': this.state.profile_data[this.state.id].id,
      });
      return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data =>{ 
             alert(data.message)
             this.setState({show_demo_options:false,demo_details:[],active_tab:1},()=>this.customerLeads())
            }
          )
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
    }
  }

  get_last_demo_details(){
    const url = `${getLocationOrigin()}/booking/get_last_demo_booking/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ demo_details: data.result}))
       .catch(error => error);
  }

  handlekitstatus(sub_id,kit_details){
    if(kit_details != null){
      this.setState({kit_ordered:kit_details.kit_ordered,kit_size:kit_details.jersey_size})
    }
    this.setState({selected_kit_sub:sub_id,kit_status:true})
  }

  setkitstatus(){
    if(this.state.kit_ordered == 0 || this.state.kit_size == ''){
      alert('Please enter the kit details')
    }
    else{
      const url = `${getLocationOrigin()}/subscriptionpause/save_kit_details/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
          'kit_sub_id': this.state.selected_kit_sub,
          'kit_ordered': this.state.kit_ordered,
          'kit_size': this.state.kit_size,
          'status': this.state.is_delivered
      });
      return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data =>{ 
             alert(data.message)
              this.setState({kit_status:false,kit_sub:'',kit_size:'',kit_ordered:0},()=>this.customerSubscriptions())
            }
          )
          .catch(error => {
              console.log(error);
              alert(error.message);
          });
    }
  }

  handledeletecustomer(){
    if(this.state.profile_list.length > 1 && this.state.new_customer_id == ''){
      var msg = `No customer is selected for saving the existing data, are you sure to delete the profile without copying the existing data to other profile ?`;
      var result = confirm(msg);
      if (result == true){
        this.deletecustomer()
      }
    }
    else{
      var msg = 'Do you want to delete the profile ?'
      var result = confirm(msg);
      if (result == true){
        this.deletecustomer()
      }
    }
  }

  deletecustomer(){
    const url = `${getLocationOrigin()}/customer_list/delete_profile_and_copy_data/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
        'old_customer_id': this.state.id,
        'new_customer_id': this.state.new_customer_id
    });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data =>{ 
         alert(data.message)
          this.setState({new_customer_id:''},()=>this.customerFulldetails())
          const index = this.state.profile_list.length - 1
          this.switchProfile(this.state.profile_list[index].id) 
          this.setState({show_delete_option:false})
        }
      )
      .catch(error => {
          console.log(error);
          alert(error.message);
      }); 
  }

  handlesubclose(){
    this.setState({show_delete_sub:false,selected_sub_id:'',selected_package_name:''})
  }

  cancelsub(){
    var msg = 'Do you want to delete the subscription ?'
    var result = confirm(msg);
    if (result == true){
      const url = `${getLocationOrigin()}/subscriptionpause/cancel_subscription/`
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'sub_id':this.state.selected_sub_id,                          
                        });
      console.log('Canceling Subscription');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          this.handlesubclose()
          alert(data.Message)
          this.customerSubscriptions()
        })
        .catch(error => alert(error));
    }
  }

  openEditOption(event,sub){
    var end_date = moment(sub.end_date)
    var start_date = moment(sub.start_date)
    this.setState({show_edit_sub:true,selected_sub_id:sub.id,selected_start_date:start_date,selected_end_date:end_date,
      selected_status:sub.status_type,selected_package:sub.package_id,selected_package_name:sub.package,amount:sub.amount_inc_tax,
      kit_fee_details: sub.kit_fee_subscription})

  }
  openEditCompensationClass(sub){
    var end_date = moment(sub.end_date)
    var reason = sub.compensation_classes?sub.compensation_classes.comments:''
    var extra_classes = sub.compensation_classes?sub.compensation_classes.extra_classes:0
    this.setState({edit_compensation_class:true,selected_sub_id:sub.id,selected_end_date:end_date,extra_classes:extra_classes,reason:reason})

  }
  closeEditCompensationClass(){
    this.setState({edit_compensation_class:false,selected_sub_id:'',selected_end_date:'',extra_classes:0,reason:''})
  }


  openAmountEdit(event,installment,sub_id){
   this.setState({show_edit_inst:true,installment_no:installment.number,installment_amount:installment.payment_amount,selected_sub_id:sub_id,selected_buddies:[],reason:''}) 
  }

  closeAmountEdit(){
    this.setState({show_edit_inst:false,installment_no:'',installment_amount:'',selected_sub_id:'',selected_buddies:[],reason:''}) 
  }

  getBuddies(){
    const url = `${getLocationOrigin()}/buddy/get_buddies_list/`;
    const options = {...defaultOptions};
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({buddies:data.buddies}))
        .catch(error => error); 
  } 
  
  getPackages(){
    const url = `${getLocationOrigin()}/package_details/get_all_active_packages/`;
    const options = {...defaultOptions};
    return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => this.setState({packages:data.packages,filtered_packages:data.packages,statuses:data.statuses}))
        .catch(error => error); 
  } 

  handleeditclose(){
    this.setState({show_edit_sub:false,selected_sub_id:'',selected_start_date:'',selected_end_date:'',selected_status:'',selected_package:'',
      selected_package_name:'',amount:'',selected_buddies:[],reason:'',kit_fee_details:[]})
  }

  changestartdate(date){
    this.setState({selected_start_date: date})
  }

  changeenddate(date){
    this.setState({selected_end_date: date})
  }

  handleSearchPackage(event){
    this.setState({show_packages: true})
    const search = event.target.value.toLowerCase()
    var search_list = []
    if(search == ''){
      search_list = this.state.packages 
    }
    else{
      const inputWords = search.split(" ");
      const matchedResults = [];
      this.state.packages.forEach(data => {
        let isMatch = true;
        inputWords.forEach(word => {
          if (!data.name.toLowerCase().includes(word)) {
            isMatch = false;
          }
        });
        if (isMatch) {
          search_list.push(data);
        }
      });
    }
    this.setState({filtered_packages: search_list})
  }

  onSelect(optionsList, selectedItem) {
    var temp_buddies = []
    temp_buddies.push(optionsList)
    this.setState({ selected_buddies: temp_buddies});
  }

  onChange(dataItem,event){
    this.setState({selected_buddies:dataItem.map(x =>x)});
  }

  updateIntallmentAmount(){
    if(this.state.selected_buddies.length <= 0){
      alert('Please select a concerned person')
    }
    else{
      var buddy_names = ''
      var bud_ids = []
      for( var i in this.state.selected_buddies){
        buddy_names = buddy_names + ' ' + this.state.selected_buddies[i].buddy
        bud_ids.push(this.state.selected_buddies[i].id)
      }

      var concerned_person = []
      if(this.state.selected_buddies && this.state.selected_buddies.length > 0){
        concerned_person = this.state.selected_buddies[0].id
      }

      const url = `${getLocationOrigin()}/subscriptionpause/edit_installments/`
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'sub_id':this.state.selected_sub_id,
                          'installment_no':this.state.installment_no,
                          'installment_amount':this.state.installment_amount,
                          'concerned_person':concerned_person,
                          'extra_details':bud_ids,
                          'reason':this.state.reason                         
                        });
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          this.closeAmountEdit()
          alert(data.Message)
          this.customerSubscriptions()
        })
        .catch(error => alert(error));
    }
  }

  editSubscription(){

    if(this.state.selected_buddies.length <= 0){
      alert('Please select a concerned person')
    }
    else{
      var sdate = moment(this.state.selected_start_date).format('YYYY-MM-DD')
      var edate = moment(this.state.selected_end_date).format('YYYY-MM-DD')

      var buddy_names = ''
      var bud_ids = []
      for( var i in this.state.selected_buddies){
        buddy_names = buddy_names + ' ' + this.state.selected_buddies[i].buddy
        bud_ids.push(this.state.selected_buddies[i].id)
      }

      var concerned_person = []
      if(this.state.selected_buddies && this.state.selected_buddies.length > 0){
        concerned_person = this.state.selected_buddies[0].id
      }

      const url = `${getLocationOrigin()}/subscriptionpause/edit_subscription/`
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'new_start_date':sdate,
                          'new_end_date':edate,
                          'sub_id':this.state.selected_sub_id,
                          'package':this.state.selected_package,
                          'amount':this.state.amount,
                          'concerned_person':concerned_person,
                          'extra_details':bud_ids,
                          'reason':this.state.reason,
                          'status':this.state.selected_status                          
                        });
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          this.handleeditclose()
          alert(data.Message)
          this.customerSubscriptions()
        })
        .catch(error => alert(error));
    }
  }
  editCompensationClass(){
    const url = `${getLocationOrigin()}/subscriptionpause/update_compensation_class/`
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'subscription_id':this.state.selected_sub_id,
                          'extra_class':this.state.extra_classes,
                          'end_date':this.state.selected_end_date,
                          "comments":this.state.reason                   
                        });
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            var message = data.message
          this.closeEditCompensationClass()
          window.alert(message)
        })
        .catch(error => alert(error));
  }


  renderTabButtons(active_tab) {
      
    
      return(
                <div style={{justifyContent: 'center', padding: '1%', display: 'flex', }} className="col-md-12">
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==1)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==1) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==1)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==1?'active':''}`} onClick={()=>this.handleTabClick(1)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Leads</span>  
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==2)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==2) ? '' :'0 6px 4px -4px #000', width: '33%', color: (active_tab==2)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==2?'active':''}`} onClick={()=>this.handleTabClick(2)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}> Bookings</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==3)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==3) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==3)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==3?'active':''}`} onClick={()=>this.handleTabClick(3)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Subscriptions</span>
                  </div> 
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==4)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==4) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==4)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==4?'active':''}`} onClick={()=>this.handleTabClick(4)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Support tickets history</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==5)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==5) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==5)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==5?'active':''}`} onClick={()=>this.handleTabClick(5)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Session feedbacks history</span>
                  </div> 
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==6)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==6) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==6)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==6?'active':''}`} onClick={()=>this.handleTabClick(6)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Attendence history</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==7)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==7) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==7)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==7?'active':''}`} onClick={()=>this.handleTabClick(7)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Activity history</span>
                  </div>                                                                          
                </div>
      )
    }

    renderPauseDialogue(data){
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onClick={this.handleSubmit}
            />,
        ];

        const unpause_actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onClick={this.handleSubmitUnpause}
            />,
        ];

        return(
            <div>
                <div className="col-md-3">
                    {this.state.subscription_id === data.id &&
                        <Dialog
                            actions={actions}
                            modal={false}
                            open={this.state.dialog_open}
                            onRequestClose={this.handleClose}
                            style ={{zIndex:'10000000'}}
                            bodyStyle ={{overflow:'inherit'}}

                        >
                            <div>
                                <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">Reason of Pause</div>
                                    <select name="pause_type" className="col-md-6" style={styles.item_body} onChange={this.handleChange} value={this.state.pause_type}>
                                        {localStorage.getItem('access') == 'Trespasser' ?                                       
                                            Object.keys(this.state.pause_types).map((key,index)=>(
                                            <option key={key} value={key}>{this.state.pause_types[key]}</option>
                                        ))
                                        :
                                            <option key={0} value={0}>Included in Package</option>

                                        }
                                    </select>
                                </div>
                                <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                        Date from you want to Pause (DD/MM/YYYY)
                                    </div>
                                    {/*<input type="text" style={styles.input} name="pause_start" className="required"
                                      value={this.state.pause_start} onChange={this.handleChange}/>*/}
                                    <DatePicker selected={this.state.pause_start} onChange={this.handledate} dateFormat="DD/MM/YYYY"/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                        Date till you want to Pause (DD/MM/YYYY)
                                    </div>
                                    {/*<input type="text" style={styles.input} name="pause_date" className="required"
                                      value={this.state.pause_date} onChange={this.handleChange}/>*/}
                                    <DatePicker selected={this.state.pause_date} onChange={this.handlepausedate} dateFormat="DD/MM/YYYY"/>
                                </div>
                            </div>
                        </Dialog>
                    }
                </div>
                {this.state.dialog_unpause_open == true &&
                    <Dialog
                          actions={unpause_actions}
                          modal={false}
                          open={this.state.dialog_unpause_open}
                          onRequestClose={this.handleClose}
                          style ={{zIndex:'10000000'}}
                          bodyStyle ={{overflow:'inherit'}}
                        >
                        <div>
                            <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Rejoining date (DD/MM/YYYY)
                                </div>
                                {/*<input type="text" style={styles.input} name="rejoining_date" className="required"
                                value={this.state.rejoining_date} onChange={this.handleChange}/>*/}
                                <DatePicker selected={this.state.rejoining_date} onChange={this.handlerejoindate} dateFormat="DD/MM/YYYY" />
                            </div>
                            
                        </div>
                    </Dialog>
                }
            </div>
                        
        )
    }
    renderSubscriptionTab(){
        
        return(
            <div className="cus_subscriptions">
                {this.state.customer_subscriptions.map((data, index)=>{
                    let isSpecialPackage = (data.package_type == 3 || data.package_type == 7 || data.package == "Direct Cost")
                    return(
                        <div key={index} className="col-md-12 cus_sub_a">
                            <div className="col-md-12 cus_sub_a1"> 
                                <div className="col-md-3 cus_sub_a11">{data.package}{data.session_count ? ' (' + data.session_count.sessions_attended + '/' + data.session_count.total_sessions + ')' : null }</div>
                                <div className="col-md-3 cus_sub_a12"><span style={{fontWeight:'bold',color:'black'}}>{data.gamename} :</span> {data.gamentypename}</div>
                                <div className="col-md-3 cus_sub_a13"><span style={{fontWeight:'bold',color:'black'}}>Used Pause : </span>{data.subscription_pause.length}</div>
                                <div className="col-md-3 cus_sub_a14" >
                                {(!data.installments || data.installments.length==0) &&
                                    <div className="cus_sub_a141">
                                        <a className="cus_sub_a142" target="_blank" href={"https://api.sporthood.in/api/v1/invoice/download/?subscription_id="+data.id}>Download Invoice</a>
                                    </div>
                                }
                                </div>

                            </div>
                                

                            <div className="col-md-12 cus_sub_a2">
                                <div className="col-md-3 cus_sub_a21">
                                    {/*{(localStorage.getItem('access') == 'Trespasser' || (localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_sub_edit'))) &&
                                        <div className="cus_sub_a211">
                                            <div className="cus_sub_a2111" onClick={(e)=>this.openEditOption(e,data)}><i className="fa fa-pencil-square-o"></i></div>
                                            <div className="cus_sub_a2112" onClick={(e)=>this.setState({show_delete_sub:true,selected_sub_id:data.id,selected_package_name:data.package})}><i className="fa fa-trash"></i></div>
                                        </div>
                                    }*/}
                                    <div className="cus_sub_a212"  onClick={(e)=>this.getchangehistory(e,data.id)} >View Edit History<i className="fa fa-history" aria-hidden="true" style={{paddingLeft:'5px'}}></i></div>      
                                </div>
                                <div className="col-md-3 cus_sub_a22"> <span style={{fontWeight:'bold',color:'black',}}>Start date :</span> {data.start_date}</div>
                                <div className="col-md-3 cus_sub_a23"><span style={{fontWeight:'bold',color:'black'}}>No of days left for pause :</span> {data.no_of_days_left_for_pause}</div>
                                {data.package_type == 3 ?
                                    <div className="col-md-3 cus_sub_a24 "> 
                                       {/*<div className="cus_sub_a241"> <div  onClick={()=>this.handlekitstatus(data.id,data.kit_status)} >Add Kit Status</div></div>*/}
                                    </div>
                            
                                :          
                                    <div className="col-md-3 cus_sub_a24 "> 
                                        {/*{data.status === "paused" ?
                                            <div className="cus_sub_a241" onClick={()=>this.setState({dialog_unpause_open:true, subscription_id:data.id})}>Unpause Subscription</div>
                                        :
                                            (data.total_pause > -1 && !isSpecialPackage)&&
                                                <div className="cus_sub_a241" onClick={()=>this.setState({dialog_open:true, subscription_id:data.id})} >Pause Subscription</div>
                                        }*/}
                                    </div>
                                }
                               
                            </div>
                            <div className="col-md-12 cus_sub_a3">
                                <div className="col-md-3 cus_sub_a31" style={{color:(data.status =='active'? (data.end_date < moment().format("YYYY-MM-DD")) ?'#cf1e1e':'green':data.status =='expired'?'#cf1e1e':'#8831cd')}}><span style={{fontWeight:'bold',color:'black'}}>Status : </span>{data.end_date < moment().format("YYYY-MM-DD")?'Expired':data.status}</div>
                                <div className="col-md-3 cus_sub_a32"><span style={{fontWeight:'bold',color:'black'}}>End date :</span> {data.end_date}</div>
                                <div className="col-md-3 cus_sub_a33" onClick={(e)=>this.pausehistory(e,data.id)} >View Pause history</div>
                                <div className="col-md-3 cus_sub_a34">
                                    {!isSpecialPackage && data.homebatch &&
                                        <div className="cus_sub_a341" >
                                            <span>{data.homebatch.venue_name} {data.homebatch.age_group_str} {data.homebatch.game_level_str} &nbsp; {data.gamentypename == 'Summer Camp' && moment(data.homebatch.start_date).format("MMM DD,YYYY") }</span><br></br>
                                            <span>{data.homebatch.days} &nbsp; {data.homebatch.start_time} - {data.homebatch.end_time}</span> 
                                            {/*<i className="fa fa-pencil-square-o" style={{color:'green',fontWeight:'bold',fontSize:'20px',paddingLeft: '5px' }} onClick={(e)=>this.getdetailsforbatchedit(e,data.id,'Edit',data.homebatch.venue,data.homebatch,data.homebatch.id)}></i>*/}
                                        </div>
                                    }
                                     {/*   (!isSpecialPackage) &&
                                            <div className="cus_sub_a342"  onClick={(e)=>this.getdetailsforbatchadd(e,data.id,'Add',data.venue_id)}>Add Homebatch</div>
                                    }*/}
                                </div>
                            </div>  
                            {data.is_flexible_pack &&
                                <div className="col-md-12" style={{paddingBottom:'10px',textDecoration:'underline',color:'#0d73fa',fontWeight:'bold'}} onClick={()=>{this.openEditCompensationClass(data)}}>
                                    Compensation class
                                </div>
                            }
                            
                            {data.installments && data.installments.length>0 && 
                                <div className="col-md-12 cus_sub_a4">
                                  {data.direct_cost && 
                                    <div>
                                      <span style={{fontWeight:600}}>Total Amount :</span>
                                      {" " + data.direct_cost.total_amount +' ( '+data.direct_cost.sub_amount + ' + ' + data.direct_cost.direct_cost_amount + ' )'}
                                    </div>
                                  }
                                    
                                    {data.installments.map((installment,index)=>(
                                        <div className="col-md-12  cus_sub_a41">
                                            <div className="col-md-4 cus_sub_a411" style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                                              {installment.name}
                                             {/* {(localStorage.getItem('access') == 'Trespasser' || (localStorage.getItem('permissions') && localStorage.getItem('permissions').includes('access_sub_edit'))) &&
                                                  installment.status=='Paid' &&
                                                    <div className='cus_sub_a4111' onClick={(e)=>this.openAmountEdit(e,installment,data.id)}><i className="fa fa-pencil-square-o"></i></div>
                                              }*/}
                                            </div>
                                            <div className="col-md-4 cus_sub_a412" style={{color:installment.status!='Paid'&&'red'}}>{installment.status}</div>
                                            {installment.status=='Paid' ?
                                                 <div className="col-md-4 cus_sub_a413"><div className="cus_sub_a4131"><a className="cus_sub_a41311" target="_blank" href={"https://api.sporthood.in/api/v1/invoice/download/?subscription_id="+data.id+"&installment="+installment.number}>Download Invoice</a></div></div>
                                            :
                                                <div className="col-md-4 cus_sub_a413">{'Due Date :'+installment.due_date}</div>
                                            }
                                        </div>
                                    ))}
                                </div>
                            }
                            {this.renderPauseDialogue(data)}          
                        </div>
                    )
                })}
            </div>

        )   
    }
    renderEditCompensationClass(){
        return(
            <Modal isOpen={this.state.edit_compensation_class}
                onRequestClose={()=>{this.setState({edit_compensation_class:false})}}
                style={creditStyles}
            >
                <div style={{width:'100%',display:'flex',justifyContent:'right',paddingBottom:'5px'}}>
                    <button className ="btn" onClick={()=>{this.setState({edit_compensation_class:false})}} style={{color:'red',padding:'2px'}}><i className="fa fa-close fa-2x" ></i></button>
                </div>
                <div className="col-md-12 col-xs-12" style={styles.sub_header}>
                  <h4 style={{textAlign:'center',fontWeight:'900',color:'white'}}> Edit Compensation Class </h4>
                </div>

                <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
                  <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Expiry Date</div>
                  <div className='col-md-6 col-xs-8'>
                    <DatePicker className="form-control" selected={this.state.selected_end_date} 
                                           dateFormat="DD-MM-YYYY"/>
                  </div>
                </div>
                <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
                  <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Extra Days</div>
                  <div className='col-md-6 col-xs-8'>
                    <input type="number" className="form-control" placeholder="Extra days" 
                      value={this.state.extra_classes} onChange={(event)=>this.setState({extra_classes:event.target.value})}/>
                  </div>
                </div>
                <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
                  <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Comments</div>
                  <div className='col-md-6 col-xs-8'>
                    <input type="text" className="form-control" placeholder="Comments" 
                      value={this.state.reason} onChange={(event)=>this.setState({reason:event.target.value})}/>
                  </div>
                </div>

                    <div className='col-md-12' style={{justifyContent:'center',display:'flex'}}>
                      <input className="btn btn-primary btn-lg" type="submit" value="Submit" style={{backgroundColor:'rgb(101, 70, 138)',fontWeight:'bold',color:'white'}}
                          onClick={()=>this.editCompensationClass()}/>
                    </div>


            </Modal>
        )
    }

    render() {

    
    const photo_dialog = [
      <FlatButton
        label="Close"
        primary={true}
        onClick={this.handleClose}
      />,
    ];

    const add_verification = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleVerifyClose}
        labelStyle={{color:'red'}}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.addverification}
        labelStyle={{color:'green'}}
      />,
    ];

    const edit_verification = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleVerifyClose}
        labelStyle={{color:'red'}}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.addverification}
        labelStyle={{color:'green'}}
      />,
    ];

    const add_homebatch = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleVerifyClose}
        labelStyle={{color:'red'}}
      />,
      <FlatButton
        label="Set HomeBatch"
        primary={true}
        onClick={this.postHomeBatch}
        labelStyle={{color:'green'}}
      />,
    ];

    const edit_amount = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={()=>this.closeAmountEdit()}
        labelStyle={{color:'red'}}
      />,
      <FlatButton
        label="Save"
        primary={true}
        onClick={()=>this.updateIntallmentAmount()}
        labelStyle={{color:'green'}}
      />,
    ];

    const demo_options = [
      <FlatButton
        label="Close"
        primary={true}
        onClick={()=>this.setState({show_demo_options:false,demo_details:[]})}
        labelStyle={{color:'#337ab7'}}
      />,
    ];
    
    const kit_options = [
      <FlatButton
        label="Close"
        primary={true}
        onClick={()=>this.setState({kit_status:false,kit_sub:'',kit_size:'',kit_ordered:0})}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.setkitstatus}
      />,
    ]

    const delete_subscription = [
      <FlatButton
          label="Yes"
          primary={true}
          onClick={()=>this.cancelsub()}
      />,
      <FlatButton
          label="No"
          primary={true}
          onClick={()=>this.handlesubclose()}
      />      
    ]

    
    return(
      <div style={styles.container}>
      { this.state.profile_data ? 
        <div className="row table-bordered col-md-12" style={styles.table} style={{flexDirection:'row'}}>
        <h4 style={{textAlign:'center'}}>Other Profiles</h4>
            <div className="profile_header col-md-12" style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                  
                  {
                    this.state.profile_list.map((list, index)=>(
                      <div  className="col-md-2 col9" key={index} style={{display: 'flex' ,flexDirection:'row', alignSelf: 'center', marginBottom: '4px', flexDirection: 'column', float: 'right',paddingLeft:'5%'}} className="col-md-2 col-xs-3" onClick={()=>{this.switchProfile(list.id, this.props)}}>
          
                        <Avatar size={60} src={list.photo.includes('http') ? list.photo : 'https://api.sporthood.in'+list.photo} style={{display:'flex',alignItems:'center',border:'thick solid',borderColor:(list.selected == true) ? 'green':'white',borderWidth:'3px',overflow:'hidden',borderRadius:'50%',alignSelf:'center'}}/>
                         <span style={{fontSize: '100%', fontWeight: 600, paddingTop: '1%', alignSelf: 'center' }} onClick={()=>{this.switchProfile(list.id, this.props)}}>{list.name}</span>

                      </div>))
                  }
               <div style={{flexDirection: 'column',display: 'flex' }} onClick={(e) => this.onClicked('ChildProfile')}>   
                <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', marginTop: '13px',paddingLeft:'0px'}}>
                  <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                  <span style={{fontSize: '100%', fontWeight: 600}}>Add profile</span>
                </button>
               </div>                           
            </div>  
            


  <div style={{width:'100%'}}>
    <table style={{width:'100%',marginBottom:'2%'}}>
      <tr>
        <td>
            <div style={{display:'flex',flexDirection:'column'}}>
              <Avatar size={90} src={this.state.profile_data[this.state.id].photo.includes('http')? this.state.profile_data[this.state.id].photo : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].photo} />
              <span style={{fontWeight: 600, paddingTop: '1%', color: '#000'}}>{this.state.profile_data[this.state.id].name}</span>
              <span style={{fontWeight: 600, paddingTop: '1%', color: '#000'}}>{this.state.profile_data[this.state.id].mobile_no}</span>
               <div onClick={(e) => this.onClicked('EditProfile')} style={{marginTop:'20px', backgroundColor: '#FDD60B', color: '#000',marginBottom: '2px',borderRadius: '4px', border: 'none',padding:'5px 20px',textAlign:'center',cursor:'pointer',width:'fit-content'}}>
                       Edit Profile
               </div>   
               <div onClick={(e) => this.onClicked('EditLead')} style={{marginTop:'10px',backgroundColor: '#FDD60B',color: '#000',marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'5px 20px',textAlign:'center',cursor:'pointer',width:'fit-content'}}>
                      Edit Lead
               </div>   

            </div>
        </td>
        
      </tr>
    </table>

    {this.state.show_demo_options && this.state.demo_details &&
      <Dialog
          actions={demo_options}
          modal={false}
          open={this.state.show_demo_options}
          onRequestClose={()=>this.setState({show_demo_options:false})}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >        
          <div className="col-md-12 col-xs-12" style={styles.sub_header}>
            <h4 style={{textAlign:'center',fontWeight:'900'}}> Demo Details </h4>
          </div>
          <div style={{textAlign:'center',marginBottom:'2%'}}>
            {
            this.state.demo_details.venue + ' ' +this.state.demo_details.game + ' ' +
            this.state.demo_details.game_type + ' ' +
            moment(this.state.demo_details.time,"HH:mm:ss").format('hh:mm A') +' - ' + 
            moment(this.state.demo_details.end_time,"HH:mm:ss").format('hh:mm A')+ ' on ' + 
            moment(this.state.demo_details.date).format('DD-MM-YYYY')
            }
          </div>
          <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
            <button className='btn btn-primary' style={{fontWeight:'900',backgroundColor:'#337ab7'}} onClick={this.canceldemo}>
              <i className="fa fa-times" aria-hidden="true"></i>&nbsp;Cancel Demo</button>
            <button className='btn btn-primary' style={{fontWeight:'900',backgroundColor:'#337ab7'}} onClick={this.reschedleDemo}>
              <i className="fa fa-dot-circle-o" aria-hidden="true"></i>&nbsp;Re-Schedule Demo</button>
          </div>        
      </Dialog>

    }

    {this.state.addVerification &&
      <Dialog
          actions={add_verification}
          modal={false}
          open={this.state.addVerification}
          onRequestClose={this.handleVerifyClose}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >
        
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Add Verification </h4>
        </div>
        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Customer</div>
          <div className="col-md-6 col-xs-8">
            {this.state.profile_data[this.state.id].name} : {this.state.profile_data[this.state.id].mobile_no}
          </div>
        </div>
      
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Venue</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="selected_venue_id" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} >
              <option>--select a venue--</option>
              {this.state.venue_list.map((venue,index) =>
              <option key={venue.id} value={venue.id}>{venue.value}</option>
              )} 
            </select>
          </div>
        </div>
    
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Member Type</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="member_type" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} >
              <option>--select member type--</option>
              {this.state.member_types.map((member,index) =>
              <option key={member.id} value={member.id}>{member.type}</option>
              )}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Image</div>
          <div className="col-md-6 col-xs-8">
            <input type="file" className="form-control" name= "verification_photo" style={{marginRight:'5px'}} 
            onChange={this.imageChange.bind(this)}/>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Number</div>
          <div className="col-md-6 col-xs-8">
            <input type="text" className="form-control" placeholder="enter card Number" 
              name= "card_number" onChange={(e)=>this.handleInputChange(e)} 
              />
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'3%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>End Date</div>
          <div className="col-md-6 col-xs-8">
            <DatePicker selected={this.state.end_date} onChange={this.handleexpdate} dateFormat="DD/MM/YYYY"/>
          </div>
        </div>
      </Dialog>
    }
    
    {this.state.community_member_status ?
      <Dialog
          actions={edit_verification}
          modal={false}
          open={this.state.editVerification}
          onRequestClose={this.handleVerifyClose}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Edit Verification </h4>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Customer</div>
          <div className="col-md-6 col-xs-8">
            {this.state.profile_data[this.state.id].name} : {this.state.profile_data[this.state.id].mobile_no}
          </div>
        </div>
      
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Venue</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="selected_venue_id" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} value={this.state.verification_details.selected_venue_id}>
              <option>--select a venue--</option>
              {this.state.venue_list.map((venue,index) =>
              <option key={venue.id} value={venue.id}>{venue.value}</option>
              )} 
            </select>
          </div>
        </div>
    
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Member Type</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="member_type" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} value={this.state.verification_details.member_type}>
              <option>--select member type--</option>
              {this.state.member_types.map((member,index) =>
              <option key={member.id} value={member.id}>{member.type}</option>
              )}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Image</div>
          <div className="col-md-6 col-xs-8">
            <input type="file" className="form-control" name= "verification_photo" style={{marginRight:'5px'}} 
            onChange={this.imageChange.bind(this)}/>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Number</div>
          <div className="col-md-6 col-xs-8">
            <input type="text" className="form-control" placeholder="enter card Number" value={this.state.verification_details.card_number}
              name= "card_number" onChange={(e)=>this.handleInputChange(e)} 
              />
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'3%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>End Date</div>
          <div className="col-md-6 col-xs-8">
            <DatePicker selected={this.state.end_date} onChange={this.handleexpdate} dateFormat="DD/MM/YYYY"/>
          </div>
        </div>

      </Dialog>
      :''
    }
    
    {this.state.community_member_status &&
      <div style={{marginTop:'1%'}}>
        {this.state.community_member_status.is_member && this.state.community_member_status.is_verified ?
          <div className="col-xs-12 col-md-6" style={{width:'100%',display:'flex',flexDirection:'row',fontWeight:900}}>
            <i className="fa fa-check-circle" style={{color:'green',fontSize:'25px',paddingRight:'5px'}} aria-hidden="true"></i>
            <span style={{paddingRight:'5px',paddingTop:'2px'}}>{this.state.community_member_status.venue_name} Verified Customer</span>
            {!this.state.open_file &&
            <button name="cancel_verification" style={{marginRight:'5px'}}  onClick={()=>this.verifyStudent('cancel_verification')}>Cancel</button> 
            }
            {this.state.community_member_status.card_imge &&
              <button name="view_photo" onClick={()=>this.setState({view_photo:true})}><i className="fa fa-eye" style={{paddingRight:'2px'}} aria-hidden="true"></i>View Photo</button>              
              // <button name="add_photo" onClick={()=>this.setState({open_file:true})}><i className="fa fa-camera" style={{paddingRight:'2px'}} aria-hidden="true"></i>Add Photo</button>
            }
          </div>
         :
         this.state.community_member_status.is_member && !this.state.community_member_status.is_verified ?
          <div className="col-xs-12 col-md-6" style={{width:'100%',display:'flex',flexDirection:'row'}}>
            <span style={{paddingRight:'5px',paddingTop:'5px',fontWeight:900}}> Is this a verfied customer of {this.state.community_member_status.venue_name} ?</span>
            <button name="verified" onClick={()=>this.verifyStudent('verified')} className="btn btn-success">Yes</button>
            <button name="not_verified" onClick={()=>this.verifyStudent('not_verified')} className="btn btn-danger">No</button>        
          </div>
          :null
        }
      </div>
    }
      {/*this.state.open_file &&
        <div className="col-xs-12 col-md-4" style={{display:'flex',flexDirection:'row',fontWeight:900,marginTop:'1%'}}>
          <input type="file" className="form-control" name= "verification_photo" style={{marginRight:'5px'}} 
                  onChange={this.fileHandler.bind(this)}/>
          <button name="add_photo" onClick={()=>this.verifyStudent('upload_photo')} style={{marginRight:'5px'}}>Upload</button>
          <button onClick={()=>this.setState({open_file:false,file:''})}>Close</button>       
        </div>
      */}
      {this.state.view_photo &&
        <Dialog
            title="Verification Photo"
            actions={photo_dialog}
            modal={false}
            open={this.state.view_photo}
            onRequestClose={this.handleClose}
            style ={{zIndex:'10000000'}}
            bodyStyle ={{overflow:'inherit'}}
          >
          <div className="col-md-12" style={{textAlign:'center',marginBottom:'3%'}}>
            <img width="200" height="200" src={this.state.community_member_status.card_imge.includes('http') ? this.state.community_member_status.card_imge : 'https://api.sporthood.in'+this.state.community_member_status.card_imge} />
          </div>
        </Dialog>
      }

    {this.state.addHomeBatch &&
      <Dialog
          actions={add_homebatch}
          modal={false}
          open={this.state.addHomeBatch}
          onRequestClose={this.handleVerifyClose}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> {this.state.batch} HomeBatch </h4>
        </div>
                                                      
        {this.state.batch == 'Edit' &&
        <div className="alert alert-info col-md-12 col-xs-12" style={{textAlign:'center',fontWeight:600,marginBottom:'2%'}}>
          Active Homebatch: {this.state.prev_homeBatch.venue_name} &nbsp; {this.state.prev_homeBatch.start_time} - {this.state.prev_homeBatch.end_time} &nbsp; {this.state.prev_homeBatch.days} &nbsp;
        </div>
        }
      
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Choose Venue</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="selected_venue_for_homebatch" style={{width:'100%',padding:'6px'}}
              value={this.state.selected_venue_id} onChange={(e)=>this.handleVenueChange(e)} >
              <option>--select a venue--</option>
              {this.state.venues.map((venue,index) =>
              <option key={venue.id} value={venue.id}>{venue.value}</option>
              )}               
            </select>
          </div>
        </div>
    
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Choose Fixture</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="selected_homebatch" style={{width:'100%',padding:'6px'}}
             value={this.state.selected_fixture_id} onChange={(e)=>this.handleBatchChange(e)}>
              <option>--select a fixture--</option>
              {this.state.fixtures.map(item=>(
                <option key={item.id} value={item.id}>{item.name}</option>  
                ))
              }
            </select>
          </div>
        </div>
      </Dialog>
    }

    {this.state.show_change_log &&
      <Modal
        isOpen={this.state.show_change_log}
        onRequestClose={()=>this.setState({show_change_log:false})}
        style={creditStyles}
      >
        <button className ="btn" onClick={()=>this.setState({show_change_log:false})} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
        <div className="col-md-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Subscription Change History </h4>
        </div>
        <div className="col-md-12">
          {this.state.change_logs && this.state.change_logs.length > 0 ?
          
            <Table responsive className="table-hover col-md-12">
              <tbody>
                <tr>
                  <th style={{textAlign:'center'}}>Type</th>
                  <th style={{textAlign:'center'}}>Changes</th>
                  <th style={{textAlign:'center'}}>Concerned Person</th>
                  <th style={{textAlign:'center'}}>Reason</th>
                </tr>
                
                {this.state.change_logs && this.state.change_logs.map( (x) =>(
                  <tr>
                    <td style={{textAlign:'center'}}>{x.change_type}</td>
                    <td style={{textAlign:'center',width:'50%'}}>{x.changes}</td>
                    <td style={{textAlign:'center'}}>{x.concerned_person}</td>
                    <td style={{textAlign:'center'}}>{x.reason}</td>
                  </tr>
                ))
                }

              </tbody>
            </Table>      
          :
            <div style={{fontWeight:'900',textAlign:'center'}}>
              No Subscription Changes
            </div>
          }
        </div>
      </Modal>
    }

    {this.state.credit_view &&
      <Modal
        isOpen={this.state.credit_view}
        onRequestClose={()=>this.setState({credit_view:false})}
        style={creditStyles}
      >
        <button className ="btn" onClick={()=>this.setState({credit_view:false})} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
        <div className="col-md-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Credit History </h4>
        </div>
        <div className="col-md-12">
          {this.state.credit_details && this.state.credit_details.length > 0 ?
          
            <Table responsive className="table-hover col-md-12">
              <tbody>
                <tr>
                  <th style={{textAlign:'center'}}>Amount</th>
                  <th style={{textAlign:'center'}}>Created On</th>
                  <th style={{textAlign:'center'}}>Reason</th>
                  <th style={{textAlign:'center'}}>Description</th>
                  <th style={{textAlign:'center'}}>Added By</th>
                </tr>
                
                {this.state.credit_details && this.state.credit_details.map( (x) =>(
                  <tr>
                    <td style={{textAlign:'center'}}>Rs:{x.amount}</td>
                    <td style={{textAlign:'center'}}>{moment(x.created_on).format('MMM DD, YYYY')}</td>
                    <td style={{textAlign:'center'}}>{x.reason}</td>
                    <td style={{textAlign:'center'}}>{x.description}</td>
                    <td style={{textAlign:'center'}}>{x.buddy}</td>
                  </tr>
                ))
                }

              </tbody>
            </Table>      
          :
            <div style={{fontWeight:'900',textAlign:'center'}}>
              No Credit History
            </div>
          }
        </div>
      </Modal>
    }

    {
      <Modal
        isOpen={this.state.show_history}
        onRequestClose={()=>this.setState({show_history:false})}
        style={creditStyles}
      >
        <button className ="btn" onClick={()=>this.setState({show_history:false})} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
        <div className="col-md-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Pause History </h4>
        </div>
        <div className="col-md-12">
          {this.state.pause_history && this.state.pause_history.length > 0 ?
          
            <Table responsive className="table-hover col-md-12">
              <tbody>
                <tr>
                  <th style={{textAlign:'center'}}>Pause Start Date</th>
                  <th style={{textAlign:'center'}}>Pause End Date</th>
                  <th style={{textAlign:'center'}}>Pause Type</th>
                  <th style={{textAlign:'center'}}>Buddy</th>
                </tr>
                
                {this.state.pause_history && this.state.pause_history.map( (data,index) =>(
                  <tr>
                    <td style={{textAlign:'center'}}>{data.start_date}</td>
                    <td style={{textAlign:'center'}}>{data.end_date}</td>
                    <td style={{textAlign:'center'}}>{data.pause_type_name}</td>
                    <td style={{textAlign:'center'}}>{data.buddy}</td>
                  </tr>
                ))
                }

              </tbody>
            </Table>      
          :
            <div style={{fontWeight:'900',textAlign:'center'}}>
              No Pause History
            </div>
          }
        </div>
      </Modal>
    }


    {this.state.kit_status &&
      <Dialog
          actions={kit_options}
          modal={false}
          open={this.state.kit_status}
          onRequestClose={()=>this.setState({kit_size:'',kit_ordered:0,selected_kit_sub:'',kit_status:false})}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Add Kit Status </h4>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>No of Kits Delivered</div>
          <div className='col-md-6 col-xs-8'>
            <input type='number' className='form-control' name='no_of_kit' placeholder='enter no of kits' value={this.state.kit_ordered}
            onChange = {(event)=>this.setState({kit_ordered: event.target.value})} />
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Jersey Size</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" value={this.state.kit_size} style={{padding:'6px', width: 'auto'}}onChange = {(event)=>this.setState({kit_size: event.target.value})}>
                <option value = {""}> Select an option </option>  
                <option value = {24}> 6XS - 24 </option>  
                <option value = {26}> 5XS - 26 </option>  
                <option value = {28}> 4XS - 28 </option>  
                <option value = {30}> 3XS - 30 </option>  
                <option value = {32}> 2XS - 32 </option>  
                <option value = {34}> XS - 34 </option>  
                <option value = {36}> S - 36 </option>  
                <option value = {38}> M - 38 </option>  
                <option value = {40}> L - 40 </option>  
                <option value = {42}> XL - 42</option>  
                <option value = {44}> 2XL - 44</option>  
            </select>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Is Kit Delivered</div>
          <div className='col-md-6 col-xs-8'>
            <div className="col-md-3">                    
              <input type='checkbox' name='is is_delivered' checked={this.state.is_delivered == false ? true : false} onChange={(event)=>{this.setState({is_delivered:false})}}/>
              &nbsp;<span>No</span>
            </div>
            <div className="col-md-3">
              <input type='checkbox' name='is is_delivered' checked={this.state.is_delivered == true ? true : false} onChange={(event)=>{this.setState({is_delivered:true})}}/>
              &nbsp;<span>Yes</span>
            </div> 
          </div>
        </div>
        

        
      </Dialog>    

    }

    {this.state.show_delete_option &&
      <Modal
        isOpen={this.state.show_delete_option}
        onRequestClose={()=>this.setState({show_delete_option:false,new_customer_id:''})}
        style={creditStyles}
      >
      <button className ="btn" onClick={()=>this.setState({show_delete_option:false,new_customer_id:''})} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
        <div className="col-md-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Delete Profile </h4>
        </div>

        <div className='col-md-12' style={{display:'flex',flexDirection:'row'}}>
          <div className='col-md-6' style={{fontWeight:'900',fontSize:'medium'}}>
            Select a profile to save the active subscriptions and bookings
          </div>

          <div className = 'col-md-6'>
            <select className='form-control' onChange = {(event)=>this.setState({new_customer_id: event.target.value})}>
              <option value=''>please select a profile</option>
              {this.state.profile_list.map((profile,index)=>(
                profile.id != this.state.id &&
                  <option value={profile.id}>{profile.name}</option>
                ))
              }
            </select>
          </div>

        </div>

        <div className='col-md-12' style={{justifyContent:'center',display:'flex', marginTop:'5%'}}>
          <input className="btn btn-primary btn-lg" type="submit" value="Delete and merge" style={{backgroundColor:'rgb(101, 70, 138)',fontWeight:'bold',color:'white'}}
              onClick={this.handledeletecustomer}/>
        </div>

      </Modal>
    }

    {this.state.show_delete_sub &&
      <Dialog
        actions={delete_subscription}
        modal={false}
        open={this.state.show_delete_sub}
        onRequestClose={()=>this.handlesubclose()}
        style ={{zIndex:'10000000'}}
        bodyStyle ={{overflow:'inherit'}}
      >
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Delete Subscription </h4>
        </div>

        <div style={{textAlign:'center'}}>
          <div>{this.state.selected_package_name}</div>
        </div>

      </Dialog>

    }
    {this.state.edit_compensation_class &&
        this.renderEditCompensationClass()
    }
    {this.state.show_edit_sub &&
      <Modal
        isOpen={this.state.show_edit_sub}
        onRequestClose={()=>this.handleeditclose()}
        style={creditStyles}
      >
      <button className ="btn" onClick={()=>this.handleeditclose()} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Edit Subscription </h4>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Start Date</div>
          <div className='col-md-6 col-xs-8'>
            <DatePicker className="form-control" selected={this.state.selected_start_date} 
                                  onChange={this.changestartdate} dateFormat="DD-MM-YYYY"/>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>End Date</div>
          <div className='col-md-6 col-xs-8'>
            <DatePicker className="form-control" selected={this.state.selected_end_date} 
                                  onChange={this.changeenddate} dateFormat="DD-MM-YYYY"/>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Status</div>
          <div className='col-md-6 col-xs-8'>
            <select name="status" className="form-control" value={this.state.selected_status} 
                  onChange={(event)=>this.setState({selected_status:event.target.value})}>
              { this.state.statuses &&
                this.state.statuses.map((x, index) => (
                <option key={x.id} value={x.id}>{x.role}</option>
                ))
              }
            </select>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Package</div>
          <div className='col-md-6 col-xs-8'>
            <div className="dropdown">
            {this.state.search_field ?
              <div className='input-group'>
                <input className="form-control" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style={{width: '100%', float: 'left'}} onChange={(event)=>this.handleSearchPackage(event)}/>
                <span className="input-group-addon" id="basic-addon1" onClick={()=>this.setState({search_field: false, filtered_packages: this.state.packages, show_packages: false})} style={{cursor: 'pointer'}}><i className="fa fa-close" aria-hidden="true"></i> </span>
              </div>
              :
              <button className="btn btn-default dropdown-toggle" style = {styles.dropdown} type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                      onClick={()=>this.setState({search_field: true, filtered_venues: this.state.venues, show_packages: true})}>
                {this.state.selected_package_name}
                <span className="caret" style={{marginTop:'8px'}}></span>
              </button>
            }
            {this.state.show_packages &&
              <ul className="dropdown-menu" aria-labelledby="dropdownMenu2" style = {styles.dropdownMenu2}>
                {
                  this.state.filtered_packages.map(item=>(
                      <li><a onClick={()=>this.setState({selected_package: item.pk,selected_package_name:item.name, filtered_packages: this.state.packages,search_field:false,show_packages:false})} style={{cursor:'pointer'}}> {item.name} </a></li>
                    ))
                }
              </ul>
            }
            </div>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Amount</div>
          <div className='col-md-6 col-xs-8'>
            <input type="number" className="form-control" placeholder="enter amount" 
              value={this.state.amount} onChange={(event)=>this.setState({amount:event.target.value})}/>
              {this.state.kit_fee_details &&
                <span style={styles.warningText}>
                  Payment collected for this subscritption (Inclusive of kit fee, GST etc)
                </span>
              }
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Concerned Person</div>
          <div className='col-md-6 col-xs-8'>                      
            <Multiselect
              id="1"  
              placeholder="Buddies"
              data={this.state.buddies}
              value = {this.state.selected_buddies}
              textField='buddy'
              onSelect={this.onSelect} 
              onChange={this.onChange}
              filter='contains' 
              />
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Reason</div>
          <div className='col-md-6 col-xs-8'>
            <input type="text" className="form-control" placeholder="enter Reason" 
              value={this.state.reason} onChange={(event)=>this.setState({reason:event.target.value})}/>
          </div>
        </div>

        <div className='col-md-12' style={{justifyContent:'center',display:'flex'}}>
          <input className="btn btn-primary btn-lg" type="submit" value="Submit" style={{backgroundColor:'rgb(101, 70, 138)',fontWeight:'bold',color:'white'}}
              onClick={()=>this.editSubscription()}/>
        </div>


      </Modal>

    }

    {this.state.show_edit_inst &&
      <Dialog
          actions={edit_amount}
          modal={false}
          open={this.state.show_edit_inst}
          onRequestClose={()=>this.closeAmountEdit()}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Edit Amount for Installent {this.state.installment_no} </h4>
        </div>
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Installment Number</div>
          <div className='col-md-6 col-xs-8'>
            <span className='form-control'>{this.state.installment_no}</span>
          </div>
        </div>
        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Paid Amount</div>
          <div className='col-md-6 col-xs-8'>
            <input type="number" className="form-control" placeholder="enter amount" 
              value={this.state.installment_amount} onChange={(event)=>this.setState({installment_amount:event.target.value})}/>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Concerned Person</div>
          <div className='col-md-6 col-xs-8'>                      
            <Multiselect
              id="1"  
              placeholder="Buddies"
              data={this.state.buddies}
              value = {this.state.selected_buddies}
              textField='buddy'
              onSelect={this.onSelect} 
              onChange={this.onChange}
              filter='contains' 
              />
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Reason</div>
          <div className='col-md-6 col-xs-8'>
            <input type="text" className="form-control" placeholder="enter Reason" 
              value={this.state.reason} onChange={(event)=>this.setState({reason:event.target.value})}/>
          </div>
        </div>
      </Dialog>
    }

    <table style={{width:'100%'}}>
           <tr>
           <td style={{width:'50%'}}>
                <div>
                  <div className="col-xs-12 col-md-6">
                    <div style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].customer_type) ?'#000' : '#FF0000', whiteSpace: 'nowrap',}}>
                    <span>Type:</span> <span>{this.state.profile_data[this.state.id].customer_type ? this.state.profile_data[this.state.id].customer_type : "No data"}</span></div>
                    <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].email)? '#000': '#FF0000'}}>
                      <div>Email:</div> <div>{this.state.profile_data[this.state.id].email ? this.state.profile_data[this.state.id].email : "No data"}</div>
                    </div>
                    <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].date_of_birth)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>DOB: {this.state.profile_data[this.state.id].date_of_birth ? this.state.profile_data[this.state.id].date_of_birth : "No data"}</span></div>
                    <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].gender)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Gender: {this.state.profile_data[this.state.id].gender ? this.state.profile_data[this.state.id].gender : "No data"}</span></div>
                    <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].source)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Lead Source: {this.state.profile_data[this.state.id].source ? this.state.profile_data[this.state.id].source : "No data"}</span></div>
                    
                  </div> 
                </div>
            </td>
            <td>    
                  {
                  this.state.profile_data[this.state.id].customer_type == 'Child' &&
                  <div>
                    <div className="col-xs-12 col-md-6">
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px',color: (this.state.profile_data[this.state.id].father_name)? '#000':'#FF0000'}}>
                        <div>Father's Name:</div>
                        <div>{this.state.profile_data[this.state.id].father_name ? this.state.profile_data[this.state.id].father_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].father_number)? '#000':'#FF0000'}}>
                        <div>Father's  No:</div> <div>{this.state.profile_data[this.state.id].father_number ? this.state.profile_data[this.state.id].father_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', fontWeight: 600,display: 'flex',flexWrap: 'wrap', marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_name)? '#000':'#FF0000'}}>
                        <div>Mothers Name:</div> <div>{this.state.profile_data[this.state.id].mother_name ? this.state.profile_data[this.state.id].mother_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_number)? '#000':'#FF0000'}}>
                        <div>Mothers No:</div> <div>{this.state.profile_data[this.state.id].mother_number ? this.state.profile_data[this.state.id].mother_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].apartment)? '#000':'#FF0000'}}>
                        <div>Apartment:</div> <div>{this.state.profile_data[this.state.id].apartment ? this.state.profile_data[this.state.id].apartment : "Nil"}</div>
                      </div>
                      <span style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].address)? '#000':'#FF0000' }}>Address: {this.state.profile_data[this.state.id].address ? this.state.profile_data[this.state.id].address.substring(0,70) : "Nil"}</span>
                    </div>

                    <div className="col-xs-12 col-md-6">
                      {this.state.profile_data[this.state.id].student_info && this.state.profile_data[this.state.id].student_info.school_name &&
                        <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px',color:'#000'}}>
                          <div>School Name:</div>
                          <div style={{paddingLeft:'15px'}}>{this.state.profile_data[this.state.id].student_info.school_name}</div>
                        </div>
                      }
                      {this.state.profile_data[this.state.id].student_info && this.state.profile_data[this.state.id].student_info.id_proof &&
                        <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px',color:'#000'}}>
                          <div>Qatar Id:</div>
                          <a style={{paddingLeft:'15px',textDecoration:'underline'}}
                            href={this.state.profile_data[this.state.id].student_info.id_proof.includes('http') ? this.state.profile_data[this.state.id].student_info.id_proof : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].student_info.id_proof}
                            target='_blank'>View Image</a>
                        </div>
                      }
                      {this.state.profile_data[this.state.id].student_info && this.state.profile_data[this.state.id].student_info.insurance_card &&
                        <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px',color: '#000'}}>
                          <div>Insurance Card:</div>
                          <a  style={{paddingLeft:'15px',textDecoration:'underline'}} 
                            href={this.state.profile_data[this.state.id].student_info.insurance_card.includes('http') ? this.state.profile_data[this.state.id].student_info.insurance_card : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].student_info.insurance_card}
                            target='_blank'>View Image</a>
                        </div>
                      }
                      </div>
                  </div>
                }                
            </td>
          </tr>      
    </table>
  </div>

          <div className="bottom_tabs col-md-12 " style={{flexDirection:'column',display:'flex', justifyContent: 'space-between', marginTop: '50px', border: '1px solid #eee',width:'100%'}}>
           <div className="col-md-12">
            {this.renderTabButtons(this.state.active_tab)}
          </div> 
          <div className="col-md-12 " style={{ justifyContent: 'space-between'}}>
          {
            (this.state.active_tab==1 ) ?
              <div className="col-md-12 " style={{ backgroundColor: '#fff'}}>
                <div >
                    <div style={{backgroundColor: '#c5c0c0', flexDirection: 'row',display: 'flex', marginBottom: '1%', padding: '1%', height: 'auto'}}>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '900' }}>Follow Up Date</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '900'}}>Buddy</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '900'}}>Venue</span>
                         </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '900' }}>Updated On</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '900'}}>Status</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'40%'}}>
                         <span style={{fontWeight: '900',color: '#000'}}>Comment</span>
                        </div>


                      </div>
                  {
                      this.state.customer_leads.map((lead, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display: 'flex', marginBottom: '1%', padding: '1%', height: 'auto'}}>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>{moment(lead.follow_up_date).format('DD MMM YYYY')}</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{ lead.created_by != null && lead.created_by }</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.venue}</span>
                         </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>{lead.created_on}</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.status}</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'40%'}}>
                         <span style={{color: '#000', fontWeight: '600'}}>{lead.comment}</span>
                        </div>


                      </div>

                      ))
                  }
                </div>

            </div>
            :
            (this.state.active_tab == 2) ?
            <div className="col-md-12 col7" style={{flexDirection: 'column',display: 'flex', backgroundColor: '#fff'}}>
                <div>
                  {
                    this.state.customer_bookings.map((booking, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display: 'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>
                        <div className="col-md-4 col7" style={{justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                        <div style={{color: '#000', fontWeight: '600',marginBottom:'0.5%'}}>{booking.venue}</div>
                        <div style={{color: '#000', fontWeight: '600'}}>
                          {booking.game + ' ' + booking.game_type + ' '}
                          {booking.age_group ? booking.age_group + ' ' : ''}
                          {booking.game_level ? booking.game_level : ' '}


                        </div>
                        </div>
                        
                        <div className="col-md-4 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                        <span style={{color: '#000', fontWeight: '600', }}>{booking.package}</span>
                        </div>
                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                            <span style={{color: '#000', fontWeight: '600'}}>{moment(booking.date).format('DD MMM YYYY')} {moment(booking.time,"HH:mm:ss").format('hh:mm A')}</span>
                         </div>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                           <span style={{color: '#000'}}>Status </span>
                            <span style={{color: '#000', fontWeight: '600'}}>{booking.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :(this.state.active_tab == 3) ?
                this.renderSubscriptionTab()
            :
            (this.state.active_tab == 4) ?
            <div style={{flexDirection: 'column', backgroundColor: '#fff', padding: '1%', display: 'flex',height:'auto'}}>
                  {

                    this.state.support_tickets.map((support, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display:'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{support.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000', fontWeight: '600'}}>{support.status_display}</span>
                        </div>
                         <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',fontWeight: '600'}}>{support.comment}</span>
                        </div>
                        <div className="col-md-4" style={{ justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600', }}>{support.content}</span>
                        </div>

                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{support.ticket_type_display}</span>
                        </div>
                      </div>
                      ))
                  }
            </div>
            :
            (this.state.active_tab == 5) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', padding: '1%', display: 'flex'}}>
                <div>
                  {

                    this.state.session_feedbacks.map((session, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row', display:'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000',fontWeight: '600'}}>{session.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000', fontWeight: '600'}}>{session.rating}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',fontWeight: '600'}}>{session.comment}</span>
                        </div>
                        <div className="col-md-4" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600', }}>{session.admin_comment}</span>
                        </div>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{session.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :
            (this.state.active_tab == 6) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              { this.state.result.bookings.length > 0 ?
                <div>
                  {
                    this.state.result.bookings.map((attendance, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row', marginBottom: '1%',display: 'flex', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{attendance.status}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{this.state.result.attendance_percentage}</span>
                        </div>
                        
                         
                      </div>
                      ))
                  }
                </div>
                :
                ""
              }
            </div>
            :
            (this.state.active_tab == 7) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              {this.state.activities.length > 0 ?
                <div>
                  {

                    this.state.activities.map((activity, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'column', marginBottom: '1%', height: '80px', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{activity.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{activity.updated_on}</span>
                        </div>

                        {/*<div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',  fontSize: '15px', fontWeight: '600'}}>{activity.path}</span>
                        </div>*/}
                         
                        
                      </div>
                      ))
                  }
                  </div>
                  :
                  ""
                }
                
            </div>
            :
            <div style={{height:500}}>
                    <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
                  </div>
                }

          </div>
          </div>

          </div>
          :
         <div className="loading-overlay"><Spinner name="ball-grid-pulse" color="darkturquoise"/></div>


      }
          { this.state.popUpVisible ?
            <div >

             <Modal
                isOpen={this.state.popUpVisible}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                  {(this.state.name== 'EditLead')?
                    <EditLead match={{"params":{"id":this.state.id}}}
                    onSubmit={this.closeModal}/>
                  : 
                  ((this.state.name == 'ScheduleDemo')?
                    <ScheduleDemo match={{"params":{"id":this.state.id}}}
                    onSubmit={this.closeModal}/>
                  :
                  (this.state.name == 'EditProfile') ?
                    <EditProfile match={{"params":{"id":this.state.id}}}
                    onSubmit={this.closeModal}/>
                  :
                  <ChildProfile match={{"params":{"id":this.state.id}}}
                    onSubmit={this.closeModal}/>
                  )
                  
                }
                
              </Modal>
            </div>
            :
            ""
          }
      </div>
    );
  }
}

export default CustomerDetails;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/customerDetails/index.js